// React
import { memo } from "react";

// UI
import { Badge } from "ui/components/Badge";
import { TableSearch } from "ui/components/Table/TableSearch";

// Tipovi i konstante
import { PRICE_TIER_COLUMNS } from "./consts";
import { PriceTiersCardProps } from "./types";

/**
 * Cjenovni razredi po broju vozila.
 *
 * Obračun je marginalan, kao porez na dohodak: svaki razred se računa po svojoj stopi, pa
 * dodavanje jednog vozila nikad ne skoči račun.
 *
 * Stopa je udio pune cijene, ne popust: 100 % znači punu cijenu.
 */
const PriceTiersCard: React.FC<PriceTiersCardProps> = (props: PriceTiersCardProps) => {
  const { tiers } = props;

  const isFlat = tiers.length === 1 && tiers[0].ratePercent === 100;

  return (
    <div className="p-6">
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px]">
          <p className="text-base font-bold text-slate-600 py-3">
            Cjenovni razredi po broju vozila
          </p>
          <p className="text-sm text-slate-500">
            Svaki razred se obračunava po svojoj stopi, kao porez na dohodak. Zato dodavanje
            jednog vozila nikad ne skoči račun.
          </p>

          <div className="mt-3">
            <Badge
              text={isFlat ? "Ravna cijena" : "Cijena po razredima"}
              variant={isFlat ? "secondary" : "success"}
              height="small"
              showDot
            />
          </div>
        </div>

        <div className="flex-1">
          <div>
            <TableSearch
              columns={PRICE_TIER_COLUMNS}
              data={tiers}
              selectableRows={false}
              disablePagination
            />

            {isFlat && (
              <p className="text-xs text-slate-400 mt-3">
                Jedan razred na 100 % znači da cijena ne pada. Svako vozilo se naplaćuje punom
                cijenom.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(PriceTiersCard);
